import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
  Radio,
  RadioGroup,
  FormControlLabel,
  Card,
  InputBase,
  FormControl,
  Paper
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { updateUser, getUsers } from "../../apis/MyDukanUser";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setLoadingPanel } from "../../redux/features/loading";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import ExcelExport from "components/ExcelExport/ExcelExport";

const MyDukaanUsers = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editData, setEditData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);

  const fetchUsers = async (query) => {
    if (!query && query !== '') return;

    dispatch(setLoadingPanel(true));
    try {
      const response = await getUsers(query);
      const userData = response.data.users;
      setUsers(userData);
    } catch (error) {
      toast.error("Failed to fetch users. Please try again.");
      setUsers([]);
    } finally {
      dispatch(setLoadingPanel(false));
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchUsers(searchQuery);
  };
  const handleOpenEditDialog = (user) => {
    setSelectedUser(user);
    setEditData({
      name: user.name || user.userName || "",
      email: user.userEmail || "",
      mobile: user.userPhoneNumber || "",
    });
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSelectedUser(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }; const handleUpdateUser = async () => {
    try {
      dispatch(setLoadingPanel(true));
      const updatePayload = {
        id: selectedUser.id,
        email: editData.email,
        mobile: editData.mobile
      };
      await updateUser(updatePayload);
      toast.success("User updated successfully!");
      handleCloseEditDialog();
    } catch (error) {
      toast.error("Failed to update user. Please try again.");
    } finally {
      dispatch(setLoadingPanel(false));
    }
  };
  const filteredExportData = users.map(({ productId, primaryName, imei, total, id, userName, ...rest }) => rest);

  return (
    <Box sx={{ width: '100%', bgcolor: '#F5F7FA' }}>

      <Box sx={{
        mx: 'auto',
        px: 4,
        maxWidth: '1200px',
        width: '100%',
        position: 'relative',
        pt: 3
      }}>
        <Card sx={{
          borderRadius: 1,
          boxShadow: 2,
          mb: 3,
          mt: 2,
          overflow: 'hidden'
        }}>
          <Box
            component="form"
            onSubmit={handleSearch}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
              p: { xs: 2, sm: 3 },
            }}
          >
            <Paper
              component="div"
              sx={{
                p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                border: '1px solid #e0e0e0',
                borderRadius: 1
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search by Mobile number and email"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                inputProps={{ 'aria-label': 'search users' }}
              />
              <IconButton type="submit" sx={{ p: '10px' }} aria-label="search" disabled={isLoading}>
                {isLoading ? <CircularProgress size={20} /> : <SearchIcon />}
              </IconButton>
            </Paper>
            <ExcelExport excelData={filteredExportData} fileName={"mydukanUser"} size="large" sx={{ height: 44 }} />
          </Box>
        </Card>
        <Card sx={{
          borderRadius: 1,
          boxShadow: 2,
          mb: 3,
          overflow: 'hidden'
        }}>
          <div className="block w-full overflow-x-auto py-3 px-4 lg:p-8">
            {isLoading && !users.length ? (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <table className="w-full border-collapse">
                <thead>
                  <tr>
                    <TableHeader heading="" />
                    <TableHeader heading="Name" />
                    <TableHeader heading="Email" />
                    <TableHeader heading="Phone" />
                    <TableHeader heading="City" />
                    <TableHeader heading="State" />
                    <TableHeader heading="Actions" />
                  </tr>
                </thead>
                <tbody>
                  {users.length > 0 ? (
                    users.map((user, i) => (
                      <tr key={user.id} style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}>
                        <TableElement value={i + 1} />
                        <TableElement value={user.name || user.userName || "NA"} />
                        <TableElement value={user.userEmail || "NA"} />
                        <TableElement value={user.userPhoneNumber || "NA"} />
                        <TableElement value={user.city || "NA"} />
                        <TableElement value={user.state || "NA"} />
                        <TableElement
                          value={
                            <IconButton
                              color="primary"
                              onClick={() => handleOpenEditDialog(user)}
                            >
                              <EditIcon />
                            </IconButton>
                          }
                        />
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center py-4">
                        No users found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}        </div>
        </Card>
      </Box>

      <Dialog
        open={openEditDialog}
        onClose={handleCloseEditDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Edit User
          <IconButton
            aria-label="close"
            onClick={handleCloseEditDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            name="name"
            label="Name"
            type="text"
            fullWidth
            variant="outlined"
            value={editData.name}
            onChange={handleEditChange}
            sx={{ mb: 2, mt: 2 }}
          />
          <TextField
            margin="dense"
            name="email"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            value={editData.email}
            onChange={handleEditChange}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            name="mobile"
            label="Phone"
            type="tel"
            fullWidth
            variant="outlined"
            value={editData.mobile}
            onChange={handleEditChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleUpdateUser}
            color="primary"
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MyDukaanUsers;